// extracted by mini-css-extract-plugin
module.exports = {"chatLoader":"ChatGroupList_chatLoader__XZHMP"};